import React from 'react';
import PropTypes from 'prop-types';

import './card.css';

class Card extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { title, content, emptyMessage } = this.props;
        return (
            <div className="card-container">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="card-title">{title}</div>
                        <div className="card-content">{content || emptyMessage}</div>
                    </div>
                </div>
            </div>
        );
    }
}

Card.defaultProps = {
    title: undefined,
    content: undefined,
    emptyMessage: undefined
};
Card.propTypes = {
    title: PropTypes.any,
    content: PropTypes.any,
    emptyMessage: PropTypes.any
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/card/index.jsx